import { createStore } from 'vuex';
import { apiRequest } from '@/api';
import { State, User } from '@/interfaces';
import createPersistedState from 'vuex-persistedstate';

const store = createStore<State>({
  state: {
    isAuthenticated: false,
    user: null,
    alerts: [],
    loading: false
  },

  mutations: {
    setAuthenticated(state, isAuthenticated: boolean) {
      state.isAuthenticated = isAuthenticated;
    },
    setUser(state, user: User) {
      state.user = user;
    },
    alert(state, { message, type }: { message: string, type: string }) {
      state.alerts.push({ show: true, message, type });
      setTimeout(() => {
        state.alerts.shift();
      }, 5000);
    },
    alertClose(state, index: number) {
      state.alerts.splice(index, 1);
    },
    setLoading(state, loading: boolean) {
      state.loading = loading;
    },
    removeLoading(state) {
      state.loading = false;
    }
  },

  actions: {
    async login({ commit }, { login, password }) {
      const data = await apiRequest({
        method: 'POST',
        url: '/login',
        data: { login, password }
      });
      const user: User = await apiRequest({
        method: 'GET',
        url: `/back/me`
      });
      commit('setUser', user);
      commit('setAuthenticated', true);
    },
    alert({ commit }, { message, type }: { message: string, type: string }) {
      commit('alert', { message, type });
    },
    alertClose({ commit }, index: number) {
      commit('alertClose', index);
    },
    logout({ commit }) {
      commit('setAuthenticated', false);
      commit('setUser', null);
    },
    setLoading({ commit }) {
      commit('setLoading', true);
    },
    removeLoading({ commit }) {
      commit('removeLoading', false);
    }
  },
  plugins: [createPersistedState({
    key: 'my-app',
    paths: ['user.name', 'user.modules', 'user.stores'],
    storage: window.sessionStorage,
  }) as any],
});

export default store;